export const locales = {
	filter: (plural: boolean): string => `filtre${plural ? 's' : ''}`
};
